"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeGDPRUnsubscribeLinkEnabled = exports.changeGDPREnforcementEnabled = exports.stageTrackingAnonymizationEnabled = exports.stageGDPRComplianceDisabled = exports.saveGDPRComplianceEnabled = exports.changeLeadRevisitNotificationsEnabled = exports.unstagePortalSetting = exports.stagePortalSetting = exports.stageAndSavePortalSetting = exports.StageAndSavePortalSetting = exports.StageAndSavePortalSettingActionTypes = exports.savePortalSetting = exports.SavePortalSetting = exports.SavePortalSettingActionTypes = exports.loadPortalSettings = exports.FetchPortalSettings = exports.FetchPortalSettingsActionTypes = exports.PortalSettingsActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _createAction = _interopRequireDefault(require("flux-actions/createAction"));

var _PortalSettingsKeys = _interopRequireDefault(require("settings-ui-sdk/constants/PortalSettingsKeys"));

var PortalSettingsActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_PORTAL_SETTINGS: null,
  SAVE_PORTAL_SETTING: null,
  STAGE_PORTAL_SETTING: null,
  STAGE_AND_SAVE_PORTAL_SETTING: null,
  UNSTAGE_PORTAL_SETTING: null
}, 'shared');
exports.PortalSettingsActionTypes = PortalSettingsActionTypes;
var FetchPortalSettingsActionTypes = (0, _actions.createRequestTypes)(PortalSettingsActionTypes.FETCH_PORTAL_SETTINGS);
exports.FetchPortalSettingsActionTypes = FetchPortalSettingsActionTypes;
var FetchPortalSettings = (0, _actions.createRequestActions)(FetchPortalSettingsActionTypes);
exports.FetchPortalSettings = FetchPortalSettings;
var loadPortalSettings = (0, _createAction.default)(PortalSettingsActionTypes.FETCH_PORTAL_SETTINGS);
exports.loadPortalSettings = loadPortalSettings;
var SavePortalSettingActionTypes = (0, _actions.createRequestTypes)(PortalSettingsActionTypes.SAVE_PORTAL_SETTING);
exports.SavePortalSettingActionTypes = SavePortalSettingActionTypes;
var SavePortalSetting = (0, _actions.createRequestActions)(SavePortalSettingActionTypes);
exports.SavePortalSetting = SavePortalSetting;
var savePortalSetting = (0, _createAction.default)(PortalSettingsActionTypes.SAVE_PORTAL_SETTING, (0, _actions.mapPayloadTo)('key', 'value'));
exports.savePortalSetting = savePortalSetting;
var StageAndSavePortalSettingActionTypes = (0, _actions.createRequestTypes)(PortalSettingsActionTypes.STAGE_AND_SAVE_PORTAL_SETTING);
exports.StageAndSavePortalSettingActionTypes = StageAndSavePortalSettingActionTypes;
var StageAndSavePortalSetting = (0, _actions.createRequestActions)(StageAndSavePortalSettingActionTypes);
exports.StageAndSavePortalSetting = StageAndSavePortalSetting;
var stageAndSavePortalSetting = (0, _createAction.default)(PortalSettingsActionTypes.STAGE_AND_SAVE_PORTAL_SETTING, (0, _actions.mapPayloadTo)('key', 'value'));
exports.stageAndSavePortalSetting = stageAndSavePortalSetting;
var stagePortalSetting = (0, _createAction.default)(PortalSettingsActionTypes.STAGE_PORTAL_SETTING, (0, _actions.mapPayloadTo)('key', 'value'));
exports.stagePortalSetting = stagePortalSetting;
var unstagePortalSetting = (0, _createAction.default)(PortalSettingsActionTypes.UNSTAGE_PORTAL_SETTING, (0, _actions.mapPayloadTo)('key'));
exports.unstagePortalSetting = unstagePortalSetting;

var changeLeadRevisitNotificationsEnabled = function changeLeadRevisitNotificationsEnabled(leadRevisitNotificationsEnabled) {
  return stagePortalSetting(_PortalSettingsKeys.default.LEAD_REVISIT_NOTIFICATIONS_ENABLED, leadRevisitNotificationsEnabled);
};

exports.changeLeadRevisitNotificationsEnabled = changeLeadRevisitNotificationsEnabled;

var saveGDPRComplianceEnabled = function saveGDPRComplianceEnabled() {
  return stageAndSavePortalSetting(_PortalSettingsKeys.default.GDPR_COMPLIANCE_ENABLED, 'true');
};

exports.saveGDPRComplianceEnabled = saveGDPRComplianceEnabled;

var stageGDPRComplianceDisabled = function stageGDPRComplianceDisabled() {
  return stagePortalSetting(_PortalSettingsKeys.default.GDPR_COMPLIANCE_ENABLED, 'false');
};

exports.stageGDPRComplianceDisabled = stageGDPRComplianceDisabled;

var stageTrackingAnonymizationEnabled = function stageTrackingAnonymizationEnabled(isEnabled) {
  return stagePortalSetting(_PortalSettingsKeys.default.EMAIL_SERVICES_OPEN_TRACKING_ANONYMIZATION_ENABLED, "" + isEnabled);
};

exports.stageTrackingAnonymizationEnabled = stageTrackingAnonymizationEnabled;

var changeGDPREnforcementEnabled = function changeGDPREnforcementEnabled(gdprEnforcementEnabled) {
  return stagePortalSetting(_PortalSettingsKeys.default.GDPR_ENFORCEMENT_ENABLED, gdprEnforcementEnabled);
};

exports.changeGDPREnforcementEnabled = changeGDPREnforcementEnabled;

var changeGDPRUnsubscribeLinkEnabled = function changeGDPRUnsubscribeLinkEnabled(gdprUnsubscribeLinkEnabled) {
  return stagePortalSetting(_PortalSettingsKeys.default.GDPR_UNSUBSCRIBE_LINK_ENABLED, gdprUnsubscribeLinkEnabled);
};

exports.changeGDPRUnsubscribeLinkEnabled = changeGDPRUnsubscribeLinkEnabled;